
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DTO_InspectionTemplateDetailDto_$reflection } from "../../../Shared/InspectionTemplate.js";
import { union_type, string_type, class_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../../Shared/Shared.js";

export class State extends Record {
    constructor(Templates, FormState) {
        super();
        this.Templates = Templates;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.InspectionTemplate.Overview.Types.State", [], State, () => [["Templates", RequestedValue$1_$reflection(list_type(DTO_InspectionTemplateDetailDto_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TemplatesFetched", "FetchError", "LoadPredefined", "PredefinedLoaded", "PredefinedError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.InspectionTemplate.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(DTO_InspectionTemplateDetailDto_$reflection())]], [["Item", class_type("System.Exception")]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

